import React from "react";
import { Link } from "react-router-dom";
import Header from "@/components/landing/Header";
import PageFooter from "@/components/landing/PageFooter";

const SUGGESTIONS = [
  {
    to: "/kapcsolodas-melysegei",
    eyebrow: "A kapcsolódás mélységei",
    title: "Minden kapcsolat hordoz valamilyen ajándékot",
    hint: "A kezdet — a kapu, ahonnan minden út elindul.",
  },
  {
    to: "/egy-erzes",
    eyebrow: "Egy érzés",
    title: "Néha megérkezik egy érzés",
    hint: "Amit nehéz szavakba önteni, de mégis igaz.",
  },
  {
    to: "/misszio",
    eyebrow: "Misszió",
    title: "A világkép",
    hint: "Amiben hiszek — család, kapcsolódás, belső rend.",
  },
  {
    to: "/konzultacio",
    eyebrow: "Konzultáció",
    title: "Induljunk el együtt",
    hint: "Egy találkozó, ahol valóban meghallgatlak.",
  },
];

export default function NotFound() {
  return (
    <main
      data-testid="not-found-page"
      className="bg-warm text-graphite min-h-screen flex flex-col"
    >
      <Header />
      <div className="pt-24 md:pt-28" />

      <section
        data-testid="not-found-hero"
        className="flex-1 px-6 md:px-10 py-14 md:py-20"
      >
        <div className="max-w-3xl mx-auto text-center">
          {/* Eyebrow */}
          <p
            data-testid="not-found-eyebrow"
            className="font-body text-[11px] md:text-[12px] tracking-[0.32em] uppercase text-gold mb-8 md:mb-10"
          >
            — 404 · Eltévedt ösvény
          </p>

          {/* Big italic mark */}
          <div
            aria-hidden="true"
            className="font-serif-display italic text-gold text-6xl md:text-7xl leading-none mb-6 md:mb-8 select-none"
          >
            {"\u2014"}
          </div>

          {/* Headline */}
          <h1
            data-testid="not-found-title"
            className="font-serif-display text-graphite text-4xl md:text-5xl lg:text-6xl leading-[1.15] tracking-tight mb-8 md:mb-10"
          >
            Ez az oldal nem <span className="italic text-gold">található</span>.
          </h1>

          {/* Message — personal, non-cliché */}
          <p className="font-body text-[15px] md:text-[17px] leading-[1.9] text-graphite-soft max-w-xl mx-auto mb-4">
            Lehet, hogy a link elavult, vagy egy olyan ösvényre tévedtél, amely még
            nem létezik. Ez rendben van — néha épp az ilyen pillanatok vezetnek oda,
            ahová valójában érkezni akartunk.
          </p>
          <p className="font-serif-display italic text-graphite text-[18px] md:text-[20px] leading-[1.8] max-w-xl mx-auto">
            Talán ez érdekelhet…
          </p>

          {/* Hairline separator */}
          <div className="w-24 h-px bg-gold/60 mx-auto my-10 md:my-14" />
        </div>

        {/* Suggestion cards */}
        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {SUGGESTIONS.map((s) => (
            <Link
              key={s.to}
              to={s.to}
              data-testid={`not-found-suggestion-${s.to.replace(/\//g, "") || "home"}`}
              className="group block bg-[rgba(255,255,255,0.55)] border border-hairline hover:border-gold transition-all duration-500 px-7 md:px-9 py-7 md:py-8 text-left"
            >
              <p className="font-body text-[10px] md:text-[11px] tracking-[0.28em] uppercase text-gold mb-3">
                {s.eyebrow}
              </p>
              <h2 className="font-serif-display text-graphite text-[22px] md:text-[26px] leading-[1.3] mb-3 group-hover:text-gold transition-colors duration-500">
                {s.title}
              </h2>
              <p className="font-body text-[13px] md:text-[14px] leading-[1.75] text-graphite-soft italic mb-4">
                {s.hint}
              </p>
              <span className="font-body text-[11px] tracking-[0.22em] uppercase text-graphite-soft group-hover:text-gold transition-colors duration-500">
                Ide lépek →
              </span>
            </Link>
          ))}
        </div>

        {/* Home fallback link */}
        <div className="max-w-3xl mx-auto text-center mt-14 md:mt-16">
          <Link
            to="/"
            data-testid="not-found-home-link"
            className="inline-block font-body text-[11px] md:text-[12px] tracking-[0.28em] uppercase text-graphite border-b border-gold pb-1 hover:text-gold transition-colors duration-500"
          >
            Vissza a főoldalra
          </Link>
        </div>
      </section>

      <PageFooter />
    </main>
  );
}
